/**
 * toileTheme — the Toile instance of `HouseTheme` (`@core/wall/ui/theme.ts`). Justified rows, no
 * pencil (the direction field is always on in the column, BRIEF §5), the ratio behind the bar's
 * chip (BRIEF § Ratio, askable at every basis since 2026-08-31).
 */
import {RATIO_KEYS} from '@core/wall/contract'
import type {HouseTheme} from '@core/wall/ui/theme'
import {TOILE_FACETS} from './facets'

export const toileTheme: HouseTheme = {
    id: 'toile',
    facets: TOILE_FACETS,
    targetRowHeight: 220,
    gap: 8,
    // The column's own bar width (plan `2026_09_18_armed_frame_budget.md` § D5) — unchanged from the
    // value the column used to hard-code five times over.
    armed: {barWidth: 620},
    hasRatioPicker: true,
    ratioKeys: RATIO_KEYS,
    defaultRatio: '2:3',
    verbs: {
        generate: 'Generate',
        again: 'Again',
        placeholder: {onPicture: 'What should change?', onBlank: 'What do you want to see?'},
        blankBasisLabel: 'blank canvas',
        refused: 'not something we draw',
    },
    // See theme.ts's own header doc for why this is root-relative rather than
    // TOILE_PACK_SAMPLES_BASE_URL — the ingest script's `image_key` already carries the
    // `pack-samples/toile/` prefix that base would double.
    tileImageUrl: (imageKey: string) => `/${imageKey}`,
    takeImageUrl: (imageKey: string) => `/generations/${imageKey}`,
    previewImageUrl: (rowId: string, n: number) => `/previews/${rowId}/${n}.webp`,
    // Toile has pack pages — unchanged from the literal `/${cell.tile.pack_slug}` `Wall.tsx` used to
    // hard-code at every call site before `HouseTheme.tileLabelHref` existed (wall-ending pass,
    // 2026-09-17).
    tileLabelHref: (packSlug: string) => `/${packSlug}`,
    // The first take is free: a visitor's first Generate writes (plan `2026_10_25_toile_first_take_free.md`).
    freePick: true,
    share: {
        link: true,
        fileBase: 'toile',
        words: {
            door: 'Share',
            native: 'Share…',
            download: 'Download',
            copyImage: 'Copy picture',
            copyLink: 'Copy link',
            title: 'Made on toile',
            text: 'Made on toile — make your own: {url}',
        },
    },
}
